'use strict';

var arraySlice = require('../internals/array-slice'); // https://tc39.github.io/proposal-setmap-offrom/


module.exports = function of() {
  return new this(arraySlice(arguments));
};